import type { NodeState, WorkflowNodeType } from 'flow/service/graph';

export const NODES_SUPPORTING_CONNECTOR: WorkflowNodeType[] = [
  'folder',
  'inputAttribute',
  'outputAttribute',
  'service',
  'tag',
  'matrixModel',
  'outcomeReason',
  'riskCalculation',
];


export const NODES_SUPPORTING_MENU: WorkflowNodeType[] = [
  'inputAttribute',
  'matrixModel',
  'outcome',
  'outputAttribute',
  'service',
  'snippet',
  'tag',
  'exit',
  'outcomeReason',
  'riskCalculation',
];

export const NODE_STATES_SUPPORTING_MENU: NodeState[] = [
  'hovered',
  'focused',
  'focused-hovered',
];

export const XL_NODES: Set<WorkflowNodeType> = new Set([
  'riskCalculation',
  'snippet',
]);
